import React, { useState, useEffect, useContext } from 'react'
import Wrapper from '../../../../components/common/Wrapper/Wrapper'
import service from '../../../../api/services'
import { Default_Page_Limit } from "../../../../constants/defaultValues"
import organisms from '../../../../components/organisms'
import { HeaderHeading } from '../../../../Context'
import { useToasts } from 'react-toast-notifications'

const { OrderCancelled } = organisms

const Index = () => {
  const [initialLoading, setInitialLoading] = useState(false)
  const [orderCancelledList, setOrderCancelledList] = useState<any>();
  const [limitPerPage, setLimitPerPage] = useState<number>(Default_Page_Limit);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [search, setSearch] = useState<string | undefined>();
  const { setHeader }: any = useContext(HeaderHeading);
  const [isContactLensProduct,setIsContactLensProduct]=useState<boolean>(false)
  const { addToast } = useToasts();

  useEffect(() => {
    setHeader("Procurement - Order Cancelled")
    if (initialLoading) {
      OrderCancelledList()
    }
      setInitialLoading(true)
  }, [currentPage])

  useEffect(() => {
    setCurrentPage(1)
    if (currentPage == 1) {
      OrderCancelledList()
    }
  }, [limitPerPage,search,isContactLensProduct])

  const OrderCancelledList = async () => {
    try {
        const response = await service.procurementService.OrderCancelledList({ "page": currentPage, "search": search, "limit": limitPerPage, "status": "","is_contact_lens":isContactLensProduct })
      if (response.status === 200) {
        setOrderCancelledList(response?.data)
      }
    } catch (error: any) {
      console.error(error)
      addToast(error.response.data.message, {
          appearance: 'error',
          autoDismiss: true,
          autoDismissTimeout: 3000,
      });
  }
  }

  return (
    <Wrapper>
      <OrderCancelled
        orderCancelledList={orderCancelledList}
        setSearch={setSearch}
        limit={limitPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setLimitPerPage={setLimitPerPage}
        isContactLensProduct={isContactLensProduct}
        setIsContactLensProduct={(value:boolean)=>setIsContactLensProduct(value)}
      />
    </Wrapper>
  )
}

export default Index